import { initialStoreSysIdState, actions } from "./action";

export const StoreSysIdReducer = (state = initialStoreSysIdState, action) => {
    switch (action.type) {
        case actions.STORESYSID_GET_ALL_SUCCESS:
            return {
                ...state,
                storeSysIdList: action.payload ? action.payload : {}
            };
        case actions.STORESYSID_UPDATE_SUCCESS:
            return {
                ...state,
                storeSysId: action.payload?.id ? {...action.payload, action: 'update'} : {}
            };
        case actions.STORESYSID_CREATE_SUCCESS:
            return {
                ...state,
                storeSysId: action.payload?.id ? {...action.payload, action: 'create'} : {}
            };
        case actions.STORESYSID_DELETE_SUCCESS:
            return {
                ...state,
                storeSysId: action.payload?.id ? {...action.payload, action: 'delete'} : {}
            };
        case actions.STORESYSID_RESET_SUCCESS:
            return {
                ...state,
                storeSysId: {},
                filters: {}
            };
        case actions.STORESYSID_SET_FILTERS_REQUEST:
            return {
                ...state,
                filters: action.payload || {}
            };
        default:
            return state;
    }
};
